export default __webpack_public_path__ + "static/media/player.7aa976c3.svg";